const isProduction = process.env.NODE_ENV == 'production';

const config = {
    API_HOST: isProduction
        ? 'https://ai-ats-resume-optimizer.onrender.com'
        : 'http://localhost:8000',
    ACCEPTED_FILE_TYPES: '.pdf,.docx',
    MAX_FILE_SIZE: 5 * 1024 * 1024,  // 5MB in bytes
    PDF_VIEWER_OPTIONS: {
        hideZoom: true,
        hideRotation: true,
        hideDownload: true,
        hidePrint: true,
    },
    DOCX_VIEWER_OPTIONS: {
        pluginRenderers: true
    }
};

export default config;
